const TimerTypes = {
  ADD_SECONDS_ACTIVE: "ADD_SECONDS_ACTIVE",
  ADD_SECONDS_PASIVE: "ADD_SECONDS_PASIVE"
};

export default TimerTypes;
